(function(){
function ready(fn){
if (document.readyState !== 'loading') fn();
else document.addEventListener('DOMContentLoaded', fn);
}
function setupEngineValidation(){
var form = document.getElementById('dlForm');
var prop = document.getElementById('dlEngineProp');
var group = document.getElementById('dlEngineGroup');
if (!form || !prop || !group) { setTimeout(setupEngineValidation, 250); return; }
function showError(){
var existing = document.getElementById('dlEngineRequiredErr');
if (existing) existing.remove();
var err = document.createElement('div');
err.id = 'dlEngineRequiredErr';
err.style.cssText = 'background:#fef2f2;border:1px solid #fca5a5;color:#991b1b;padding:10px 14px;border-radius:6px;margin-top:10px;font-size:13.5px;font-weight:600;';
err.innerHTML = '⚠️ Please choose <strong>2-Stroke</strong> or <strong>4-Stroke</strong> below before adding to cart.';
group.parentNode.insertBefore(err, group.nextSibling);
group.style.outline = '2px solid #d11919';
group.style.outlineOffset = '4px';
group.style.borderRadius = '6px';
group.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
function clearError(){
var existing = document.getElementById('dlEngineRequiredErr');
if (existing) existing.remove();
group.style.outline = '';
group.style.outlineOffset = '';
}
form.addEventListener('submit', function(e){
if (!prop.value) {
e.stopImmediatePropagation();
e.preventDefault();
showError();
return false;
}
}, true);
group.addEventListener('click', function(){
setTimeout(function(){ if (prop.value) clearError(); }, 50);
});
}
ready(setupEngineValidation);
function setupAddonPropDisabling(){
var pairs = [
['dlPlasticsCard','dlPlasticsProp'],
['dlSeatCard','dlSeatProp'],
['dlClearSwingCard','dlClearSwingProp'],
['dlMiniPlatesCard','dlMiniPlatesProp'],
['dlMiniPlatesCard','dlMiniPlatesQtyProp']
];
function syncOne(cardId, propId){
var card = document.getElementById(cardId);
var prop = document.getElementById(propId);
if (!card || !prop) return;
prop.disabled = !card.classList.contains('selected');
}
function syncAll(){
for (var i = 0; i < pairs.length; i++) syncOne(pairs[i][0], pairs[i][1]);
}
function tryInit(){
var card = document.getElementById('dlPlasticsCard');
if (!card) { setTimeout(tryInit, 250); return; }
syncAll();
var form = document.getElementById('dlForm') || document.body;
form.addEventListener('click', function(e){
var hit = e.target.closest && e.target.closest('#dlPlasticsCard, #dlSeatCard, #dlClearSwingCard, #dlMiniPlatesCard');
if (hit) setTimeout(syncAll, 60);
});
if (form && form.addEventListener) {
form.addEventListener('submit', function(){ syncAll(); }, true);
}
}
ready(tryInit);
}
setupAddonPropDisabling();
function setupRobustCartSubmit(){
var form = document.getElementById('dlForm');
if (!form) { setTimeout(setupRobustCartSubmit, 250); return; }
if (form._dlRobustBound) return;
form._dlRobustBound = true;
var ADDON_VARIANTS = {
miniPlates: 53003419746626,
clearSwingarm: 53003419812162,
whiteInk: 53003421155650,
seatCover: 53003421450562,
gutsCover: 53003431117122,
foamHalfBump: 53003431149890,
foamFullBump: 53003431182658,
foamStep: 53003431215426
};
function $(id){ return document.getElementById(id); }
function isSelected(id){ var c = $(id); return c && c.classList.contains('selected'); }
function val(id){ var el = $(id); return el ? (el.value || '') : ''; }
function showFeedback(text, isError){
var fb = $('dlCartFeedback');
if (fb) {
fb.className = 'cart-feedback ' + (isError ? 'error' : 'success');
fb.textContent = text;
fb.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
}
function buildAddonItems(){
var items = [];
if (isSelected('dlWhiteInkCard')) {
var wiProp = $('dlWhiteInkProp');
if (wiProp && !wiProp.disabled) items.push({ id: ADDON_VARIANTS.whiteInk, quantity: 1 });
}
if (isSelected('dlClearSwingCard')) {
items.push({ id: ADDON_VARIANTS.clearSwingarm, quantity: 1 });
}
if (isSelected('dlSeatCard')) {
var seatProps = {};
var sideC = val('dlSeatSideProp'); if (sideC) seatProps['Side Color'] = sideC;
var topC = val('dlSeatTopProp'); if (topC) seatProps['Top Color'] = topC;
var ribC = val('dlSeatRibProp'); if (ribC) seatProps['Rib Color'] = ribC;
var sh = val('dlSeatHeightProp'); if (sh) seatProps['Seat Height'] = sh;
var seatItem = { id: ADDON_VARIANTS.seatCover, quantity: 1 };
if (Object.keys(seatProps).length) seatItem.properties = seatProps;
items.push(seatItem);
if (isSelected('dlGutsCard')) {
items.push({ id: ADDON_VARIANTS.gutsCover, quantity: 1 });
var foamSel = document.querySelector('#dlSeatFoamGroup .opt-card.selected');
if (foamSel) {
var foamValue = foamSel.dataset.value || '';
var foamId = null;
if (foamValue.indexOf('1/2') >= 0) foamId = ADDON_VARIANTS.foamHalfBump;
else if (foamValue.indexOf('1"') >= 0) foamId = ADDON_VARIANTS.foamFullBump;
else if (foamValue === 'Step') foamId = ADDON_VARIANTS.foamStep;
if (foamId) items.push({ id: foamId, quantity: 1 });
}
}
}
if (isSelected('dlMiniPlatesCard')) {
var mpQty = parseInt(val('dlMiniPlatesQty'), 10) || 5;
if (mpQty < 5) mpQty = 5;
items.push({ id: ADDON_VARIANTS.miniPlates, quantity: mpQty });
}
return items;
}
function addAddonsBatch(items){
if (!items || !items.length) return Promise.resolve({ items: [] });
return fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
'Accept': 'application/json',
'X-Requested-With': 'XMLHttpRequest'
},
body: JSON.stringify({ items: items })
}).then(function(r){
return r.json().then(function(j){
if (!r.ok) {
var msg = (j && j.description) || (j && j.message) || ('Add-ons request failed (' + r.status + ')');
var err = new Error(msg);
err._payload = j;
throw err;
}
return j;
});
});
}
function trackKlaviyoAdd(item){
if (!item) return;
try {
var payload = {
Name: item.product_title || item.title,
ProductID: item.product_id,
SKU: item.sku,
ImageURL: item.image,
URL: location.origin + (item.url || ''),
Brand: item.vendor,
Price: (typeof item.price === 'number' ? item.price / 100 : item.price),
CompareAtPrice: (typeof item.original_price === 'number' ? item.original_price / 100 : null),
Quantity: item.quantity || 1,
VariantID: item.variant_id || item.id
};
if (window._learnq && typeof window._learnq.push === 'function') {
window._learnq.push(['track', 'Added to Cart', payload]);
}
if (window.klaviyo && typeof window.klaviyo.push === 'function') {
window.klaviyo.push(['track', 'Added to Cart', payload]);
}
try {
if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
window.Shopify.analytics.publish('product_added_to_cart', { cartLine: { merchandise: { id: 'gid://shopify/ProductVariant/' + (item.variant_id || item.id), product: { id: 'gid://shopify/Product/' + item.product_id, title: item.product_title || item.title, vendor: item.vendor } }, quantity: item.quantity || 1 } });
}
} catch(e){}
try { console.log('[dl-cart] Klaviyo Added to Cart fired:', payload); } catch(e){}
} catch(e){ try { console.warn('[dl-cart] Klaviyo track failed:', e); } catch(_){} }
}
function intercept(e){
var engineProp = $('dlEngineProp');
if (!engineProp || !engineProp.value) return;
e.preventDefault();
e.stopImmediatePropagation();
var btn = $('dlAddBtn');
var origText = btn ? btn.innerHTML : '';
if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
var formData = new FormData(form);
var addonItems = buildAddonItems();
try { console.log('[dl-cart] Add-on items queued:', addonItems); } catch(e){}
fetch('/cart/add.js', {
method: 'POST',
body: formData,
headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
})
.then(function(r){ return r.json().then(function(j){ return { ok: r.ok, data: j }; }); })
.then(function(res){
if (!res.ok) throw new Error((res.data && res.data.description) || 'Could not add main item');
trackKlaviyoAdd(res.data);
return addAddonsBatch(addonItems).catch(function(err1){
try { console.warn('[dl-cart] Batch add failed, retrying:', err1); } catch(e){}
return new Promise(function(resolve){ setTimeout(resolve, 400); })
.then(function(){ return addAddonsBatch(addonItems); });
});
})
.then(function(addonResult){
try { console.log('[dl-cart] Add-ons response:', addonResult); } catch(e){}
try {
if (addonResult && addonResult.items && addonResult.items.length) {
addonResult.items.forEach(function(it){ trackKlaviyoAdd(it); });
}
} catch(e){}
try { notifyThemeCart(); } catch(e){}
try { updateCartCountFallback(); } catch(e){}
showFeedback('Added to cart! Redirecting…', false);
setTimeout(function(){ window.location.href = '/cart'; }, 500);
})
.catch(function(err){
if (btn) { btn.disabled = false; btn.innerHTML = origText; }
try { console.error('[dl-cart] Cart add error:', err); } catch(e){}
var msg = (err && err.description) || (err && err.message) || 'Something went wrong adding your add-ons. Please try again or contact support.';
showFeedback('❌ ' + msg + ' (your main item was added; please review your cart)', true);
});
}
form.addEventListener('submit', intercept, true);
}
setupRobustCartSubmit();
})();
